module.exports = __webpack_public_path__ + "static/img/tiyanhao.164e6ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/tiyanhao.png
// module id = gUKJ
// module chunks = 0